import {
  clearDropDownData,
  getUserDropdown,
  setDropEditDownData,
} from '@/actions/dropdown';
import {
  Avatar,
  Button,
  Dropdown,
  Input,
  Menu,
  Modal,
  Pagination,
  Radio,
  Row,
  Skeleton,
  Spin,
  notification,
} from 'antd';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import {
  clearRoomError,
  getRoomMembers,
  inviteMemberRequest,
  removeRoomMember,
  setMemberActiveTab,
  setRoomData,
  setRoomEditData,
  updateRoomMember,
} from '../../../../../actions/room';
import { capitalizeFirstLetter } from '../../../../../helpers/dataHelper';
import AvatarComponent from '../../../../common/avatar';
import useWidth from '@/helpers/widthUtil';

const RoomMembers = ({ roomSlug }) => {
  const { isMobile, isTablet } = useWidth();
  const dispatch = useDispatch();
  const observer: any = useRef();
  const router = useRouter();

  const [query, setQuery] = useState({
    page: 1,
    per_page: 10,
    room: roomSlug,
    status: 1,
  });
  const [suspendVisible, setSuspendVisible] = useState(false);
  const [memberName, setMemberName] = useState('');
  const [suspendType, setSuspendType] = useState(null);
  const [memberId, setMemberId] = useState(null);
  const [inviteModal, setInviteModal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [value, setvalue] = useState('');
  const [radioValue, setRadioValue] = useState('');
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [userQuery, setUserQuery] = useState({
    page: 1,
    search: '',
    user_type: '',
    room: roomSlug,
  });

const members = useSelector((state: any) => state.roomReducer.members);
const activeTab = useSelector((state: any) => state.roomReducer.activeTab);
const userDropDown = useSelector((state: any) => state.dropdown.user);
const roomData = useSelector((state: any) => state.roomReducer?.roomDetail);
const inviteMemberStatus = useSelector(
  (state: any) => state.roomReducer?.inviteMemberStatus
);
const roomError = useSelector((state: any) => state.roomReducer?.error);
const user = useSelector((state: any) => state.auth?.creds?.user_data);

useEffect(() => {
  if (router?.query?.tab === 'members' && router?.query?.subtab === '2') {
    dispatch(setMemberActiveTab(parseInt(router?.query?.subtab)));
  }
}, [router]);

useEffect(() => {
  if (router?.query?.tab === 'members' || activeTab === 'members') {
    const data = {
      ...query,
      room: roomSlug,
      status: activeTab,
      page: 1,
    };
    setQuery(data);
    dispatch(getRoomMembers({ data }));
  }
}, [router?.query?.tab, activeTab]);

  useEffect(() => {
    dispatch(clearRoomError());
    dispatch(setRoomData({ key: 'inviteMemberStatus', value: '' }));
    return () => {
      dispatch(clearDropDownData(''));
      setUserQuery({
        ...query,
        page: 1,
        search: '',
        user_type: '',
      });
      setvalue('');
    };
  }, []);

  useEffect(() => {
    setHasMore(userDropDown?.meta?.last_pages === userQuery?.page ? false : true);
  }, [userDropDown]);

  useEffect(() => {
    dispatch(
      setRoomEditData({ name: 'members', key: 'updateMemberStatus', value: '' })
    );
  }, []);

  useEffect(() => {
    if (members?.updateMemberStatus === 'success') {
      setSuspendVisible(false);
    }
  }, [members?.updateMemberStatus]);

  useEffect(() => {
    if (inviteMemberStatus === 'success') {
      notification.success({ message: 'Invite Sent Successfully.' });
      setInviteModal(false);
      setvalue('');
      dispatch(setRoomData({ key: 'inviteMemberStatus', value: '' }));
    }
  }, [inviteMemberStatus]);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      dispatch(setMemberActiveTab(tab));
    }
  };

  // Fetch data when user reaches button
  const lastUserElementRef = useCallback(
    (node) => {
      if (userDropDown.userDropdownStatus === 'request') return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setUserQuery({
            ...userQuery,
            search: value,
            page: userDropDown?.meta?.current_page + 1,
          });
          dispatch(
            getUserDropdown({
              data: {
                ...userQuery,
                page: userDropDown?.meta?.current_page + 1,
                search: value,
              },
            })
          );
          dispatch(
            setDropEditDownData({
              name: 'user',
              key: 'moreLoading',
              value: 'request',
            })
          );
        }
      });
      if (node) observer.current.observe(node);
    },
    [userDropDown.userDropdownStatus === 'request', hasMore]
  );

  const searchMembers = (e) => {
    var name = e.target.value;
    dispatch(
      getRoomMembers({
        data: {
          ...query,
          name,
          status: activeTab,
        },
      })
    );
  };

  const handleRadio = (e: any, type: any) => {
    if (type === 'unsuspend') {
      setSuspendType('unsuspend');
    } else {
      setSuspendType(parseInt(e.target.id));
    }
  };

  const suspendMember = (e) => {
    var uData = {
      memberId,
      data: {
        suspend_status: suspendType === 'unsuspend' ? null : suspendType,
      },
    };
    dispatch(updateRoomMember(uData));
  };

  const onSuspendClick = (each) => {
    setMemberName(each?.user?.first_name);
    setSuspendVisible(true);
    setSuspendType(each.suspend_status);
    setMemberId(each.id);
  };

  const handlePagination = (page, pageSize) => {
    setQuery({ ...query, page, per_page: pageSize });
    dispatch(
      getRoomMembers({
        data: {
          ...query,
          page,
          per_page: pageSize,
          status: activeTab,
        },
      })
    );
  };

  const onClick = (display_name, id) => {
    setShowSuggestions(false);
    setvalue(display_name);
    setUserId(id);
  };

  let suggestionsListComponent;

  if (showSuggestions && value) {
    if (userDropDown?.data?.length !== 0) {
      suggestionsListComponent = (
        <>
          <ul className="suggestions border border-muted border-top-0">
            {userDropDown?.data?.map((suggestion, index) => {
              let className;
              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = 'suggestion-active';
              }
              const { id, username, first_name, last_name, avatar } = suggestion;
              return (
                <li
                  key={index}
                  ref={
                    userDropDown?.data?.length === index + 1
                      ? lastUserElementRef
                      : null
                  }
                  className={`${className} 
                                        iq-sub-card border border-bottom border-muted 
                                        ${
                                          index === userDropDown?.data?.length - 1 &&
                                          'border-bottom-0'
                                        }`}
                  onClick={() => onClick(`${first_name} ${last_name}`, id)}
                >
                  <div className="media align-items-center cust-card p-2">
                    <div className="">
                      <AvatarComponent
                        firstName={first_name}
                        lastName={last_name}
                        size={36}
                        avatar={
                          avatar ? process.env.NEXT_PUBLIC_MEDIA_URL + avatar : ''
                        }
                      />
                    </div>
                    <div className="media-body ml-2">
                      <h6 className="mt-1">
                        {first_name} {last_name}
                      </h6>
                      <small className="mb-0">@{username}</small>
                    </div>
                  </div>
                </li>
              );
            })}
            {userDropDown?.moreLoading === 'request' && (
              <li className="sug-loader text-center">
                <Spin />
              </li>
            )}
          </ul>
        </>
      );
    } else {
      suggestionsListComponent = (
        <div className="suggestions media align-items-center card p-2">
          <span>No suggestions available.</span>
        </div>
      );
    }
  }

  const onChange = (e) => {
    setUserQuery({ ...userQuery, page: 1, search: e.currentTarget.value });
    dispatch(clearDropDownData(''));
    setShowSuggestions(true);
    setvalue(e.currentTarget.value);
    dispatch(clearRoomError());
    dispatch(
      getUserDropdown({ data: { ...userQuery, search: e.currentTarget.value } })
    );
  };

  const onInviteClick = () => {
    setInviteModal(true);
  };

  const onRadioChange = (e) => {
    setRadioValue(e.target.value);
    setvalue('');
    setUserQuery({
      ...userQuery,
      page: 1,
      search: '',
      user_type: e.target.value,
      room: roomSlug,
    });
    dispatch(
      getUserDropdown({
        data: { ...userQuery, page: 1, search: '', user_type: e.target.value },
      })
    );
    dispatch(clearRoomError());
  };

  const inviteClick = () => {
    const data = {
      id: userId,
      url: window.location.href,
      slug: roomData.data.slug,
    };
    dispatch(inviteMemberRequest({ data }));
  };

  const MembersMenu = ({ member }) => {
    return (
      <Menu className="p-2" style={{ borderRadius: '8px' }}>
        <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
          <a onClick={() => onSuspendClick(member)}>
            <div className="dropdown-media d-flex align-items-center px-2">
              <i className="fas fa-user-slash fa-lg text-muted mr-3"></i>
              <span className="mr-3">Suspend member</span>
            </div>
          </a>
        </Menu.Item>
      </Menu>
    );
  };

  const memberLists = (
    <div className="mb-3">
      <div className="row">
        <div className="col-lg-12">
          <div className="card card-block card-stretch card-height">
            <div
              className="card-header d-flex justify-content-between "
              style={{ borderRadius: '10px' }}
            >
              <div className="iq-header-title w-100">
                <h5 className="card-title mb-0">
                  {activeTab === 1
                    ? 'Active'
                    : activeTab === 0
                    ? 'Invitation Pending'
                    : activeTab === 2
                    ? 'Invitation Rejected'
                    : activeTab === 3 && 'Suspended'}{' '}
                  Members
                </h5>
                {activeTab === 1 && (
                  <span>New people who join this group will appear here.</span>
                )}
              </div>
              <div className="filter-search w-100 mt-2">
                <label className="w-100">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="py-2 pr-3 border-0 w-100 input-placeholder text-black "
                      placeholder="Find a member"
                      onChange={(e) => searchMembers(e)}
                      style={{
                        borderRadius: '20px',
                        background: 'rgb(240, 242, 245)',
                        paddingLeft: '1.8rem',
                        fontSize: '14px',
                      }}
                    />
                    <i
                      className="fas fa-search position-absolute"
                      style={{ top: '0.8rem', left: '0.6rem' }}
                    ></i>
                  </div>
                </label>
              </div>
            </div>
            <div className="card-body">
              <div className="border-top pt-3 px-3">
                {members?.data?.length !== 0
                  ? members?.data?.map((member) => (
                      <div
                        key={member?.id}
                        className={`d-flex mb-3 align-items-center justify-content-between   ${
                          !members.loading &&
                          member?.suspend_status !== null &&
                          member?.suspend_status !== '' &&
                          'bg-danger-low-opacity'
                        } `}
                      >
                        <div
                          className="d-flex gap-2 align-items-center "
                          style={{ width: '60%' }}
                        >
                          {members.loading ? (
                            <Skeleton.Avatar />
                          ) : (
                            <div>
                              <AvatarComponent
                                firstName={member?.user?.first_name}
                                lastName={member?.user?.last_name}
                                avatar={member?.user?.avatar}
                                biggerAvatar
                                size={45}
                              />
                            </div>
                          )}
                          {members.loading ? (
                            <Skeleton.Button
                              style={{ width: '300px' }}
                              active={true}
                              size="large"
                            />
                          ) : (
                            <div
                              className="d-flex flex-column "
                              style={{
                                height: 'fit-content',
                                lineHeight: '1.5',
                                fontSize: '13px',
                              }}
                            >
                              <span
                                className="font-weight-bold text-black"
                                style={{ height: 'fit-content', lineHeight: '1.5' }}
                              >
                                {capitalizeFirstLetter(member?.user?.first_name)}{' '}
                                {capitalizeFirstLetter(member?.user?.last_name)}
                              </span>
                              <span style={{ height: 'fit-content' }}>
                                @{member?.user?.username}
                              </span>
                            </div>
                          )}
                        </div>
                        {member?.user?.id !== user?.id && member.status === 1 ? (
                          <div>
                            {members.loading ? (
                              <Avatar shape="square" size={36} />
                            ) : (
                              <div className="d-flex align-items-center list-action">
                                {/* <Tooltip title="Suspend Member" placement="bottom">
                                <a
                                  className="badge bg-warning-light mr-2"
                                  onClick={() => onSuspendClick(member)}
                                >
                                  <i className="fas fa-ellipsis-h"></i>
                                </a>
                              </Tooltip> */}
                                <Dropdown
                                  overlay={<MembersMenu member={member} />}
                                  placement="bottomLeft"
                                  className="dropdown-ml ml-auto"
                                  trigger={['click']}
                                  overlayStyle={{ minWidth: '160px' }}
                                >
                                  <div>
                                    <a className="badge bg-warning-light mr-2">
                                      <i className="fas fa-ellipsis-h"></i>
                                    </a>
                                  </div>
                                </Dropdown>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div style={{ width: '30%' }}>
                            {members.loading && <Avatar shape="square" size={36} />}
                          </div>
                        )}
                      </div>
                    ))
                  : !members.loading && (
                      <div className="text-center font-weight-bold ">
                        No Members found
                      </div>
                    )}
              </div>
              {/* <div className="table-responsive data-table">
                <table className="data-tables table w-75">
                  <thead>
                    <tr>
                      <th>Profile</th>
                      <th>Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {members?.data?.length !== 0 &&
                      members?.data?.map((member) => (
                        <tr
                          key={member?.id}
                          className={
                            !members.loading &&
                            member?.suspend_status !== null &&
                            member?.suspend_status !== '' &&
                            'bg-danger-low-opacity'
                          }
                        >
                          <td width={'10%'}>
                            {members.loading ? (
                              <Skeleton.Avatar />
                            ) : (
                              <AvatarComponent
                                firstName={member?.user?.first_name}
                                lastName={member?.user?.last_name}
                                avatar={member?.user?.avatar}
                              />
                            )}
                          </td>

                          <td width={'60%'}>
                            {members.loading ? (
                              <Skeleton.Button
                                style={{ width: '300px' }}
                                active={true}
                                size="large"
                              />
                            ) : (
                              <>
                                <span>
                                  {capitalizeFirstLetter(member?.user?.first_name)}{' '}
                                  {capitalizeFirstLetter(member?.user?.last_name)}
                                </span>
                                <span className="d-block">
                                  @{member?.user?.username}
                                </span>
                              </>
                            )}
                          </td>
                          {member?.user?.id !== user?.id && member.status === 1 ? (
                            <td width={'30%'}>
                              {members.loading ? (
                                <Avatar shape="square" size={36} />
                              ) : (
                                <div className="d-flex align-items-center list-action">
                                  <Tooltip title="Suspend Member" placement="bottom">
                                    <a
                                      className="badge bg-warning-light mr-2"
                                      onClick={() => onSuspendClick(member)}
                                    >
                                      <i className="fas fa-remove-format"></i>
                                    </a>
                                  </Tooltip>
                                </div>
                              )}
                            </td>
                          ) : (
                            <td width={'30%'}>
                              {members.loading && (
                                <Avatar shape="square" size={36} />
                              )}
                            </td>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div> */}
            </div>

            {!members.loading && members?.data?.length !== 0 && (
              <div className="card-footer bg-white">
                <Pagination
                  className="float-right"
                  defaultCurrent={query?.page}
                  total={members?.meta?.total}
                  onChange={handlePagination}
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
                  defaultPageSize={query?.per_page}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Modal
        title="Invite Users"
        visible={inviteModal}
        onCancel={() => setInviteModal(false)}
        footer={null}
        maskClosable={false}
      >
        {roomError?.inviteMember && (
          <p className="text-danger">{roomError?.inviteMember}</p>
        )}
        <Radio.Group onChange={onRadioChange} value={radioValue}>
          <Radio value="">All</Radio>
          <Radio value="staff">Staff</Radio>
          <Radio value="client">Client</Radio>
          <Radio value="instructor">Instructor</Radio>
        </Radio.Group>
        <div className="d-flex justify-content-between mt-3">
          <Input
            type="text"
            placeholder={`Search ${
              radioValue === ''
                ? 'All Users'
                : radioValue === 'staff'
                ? 'Staffs'
                : radioValue === 'instructor'
                ? 'Instructors'
                : radioValue === 'client'
                ? 'Clients'
                : ''
            } here`}
            onChange={onChange}
            value={value}
            className=" search-users py-2 pr-3 border-0 w-100 input-placeholder text-black "
            style={{
              borderRadius: '20px',
              background: 'rgb(240, 242, 245)',
              paddingLeft: '1.8rem',
              fontSize: '14px',
            }}
          />
        </div>
        {suggestionsListComponent}
        <div className="d-flex align-items-center gap-2 justify-content-end mt-5">
          <Button
            className="border-0 px-4"
            onClick={() => setInviteModal(false)}
            style={{ boxShadow: 'unset', color: '#283360' }}
          >
            Cancel
          </Button>
          <Button
            loading={inviteMemberStatus === 'request' ? true : false}
            className="btn-primary px-5"
            onClick={inviteClick}
            disabled={value ? false : true}
            style={{ borderRadius: '5px !important' }}
          >
            Invite User
          </Button>
        </div>
      </Modal>
      <Modal
        title="Suspend Member"
        visible={suspendVisible}
        onCancel={() => setSuspendVisible(false)}
        footer={null}
        // centered={windowSize.current > 1400}
        maskClosable={false}
      >
        {/* <PermissionHandler permission={permission?.roommember?.change_roommember}> */}
        <div className="d-flex flex-column">
          <span className="font-weight-bold">
            How long do you want to suspend {memberName ? memberName : 'user'}?
          </span>
          <span>
            They'll be able to view the group, but won't be able to post, comment, or
            take other actions in the chosen time frame.
          </span>
        </div>
        <div className=" discussion-member">
          <div className="content-type-radio">
            <input
              id="null"
              name="radio"
              type="radio"
              checked={suspendType === 'unsuspend'}
              onChange={(e) => {
                handleRadio(e, 'unsuspend');
              }}
            />
            <label htmlFor="null" className="font-weight-bold px-0">
              Unsuspend
            </label>
          </div>
          <div className="content-type-radio">
            <input
              id="0"
              name="radio"
              type="radio"
              checked={suspendType === 0}
              onChange={(e) => {
                handleRadio(e, 0);
              }}
            />
            <label htmlFor="0" className="font-weight-bold px-0">
              15 Minutes
            </label>
          </div>
          <div className="content-type-radio">
            <input
              id="1"
              name="radio"
              type="radio"
              checked={suspendType === 1}
              onChange={(e) => handleRadio(e, 1)}
            />
            <label htmlFor="1" className="font-weight-bold px-0">
              30 Minutes
            </label>
          </div>
          <div className="content-type-radio">
            <input
              id="2"
              name="radio"
              type="radio"
              checked={suspendType === 2}
              onChange={(e) => handleRadio(e, 2)}
            />
            <label htmlFor="2" className="font-weight-bold px-0">
              1 Day
            </label>
          </div>
          <div className="content-type-radio">
            <input
              id="3"
              name="radio"
              type="radio"
              checked={suspendType === 3}
              onChange={(e) => handleRadio(e, 3)}
            />
            <label htmlFor="3" className="font-weight-bold px-0">
              Always
            </label>
          </div>
        </div>
        {/* </PermissionHandler> */}

        <div className="d-flex align-items-center gap-2 justify-content-end">
          <Button
            className="border-0 px-4"
            onClick={() => setSuspendVisible(false)}
            style={{ boxShadow: 'unset', color: '#283360' }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="px-5"
            onClick={(e) => suspendMember(e)}
            style={{ borderRadius: '5px' }}
            loading={members?.updateMemberStatus === 'request'}
          >
            Suspend
          </Button>
        </div>
      </Modal>
      <div className={`container ${(isMobile || isTablet) && 'px-0'}`}>
        <Row>
          <Nav className="flex-column">
            <NavItem>
              <NavLink
                className={`${
                  isMobile ? 'px-1 mr-1 font-size-sm' : ''
                }  ${classnames({
                  active: activeTab === 1,
                })}`}
                onClick={() => {
                  toggle(1);
                }}
              >
                Active
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`${
                  isMobile ? 'px-1 mr-1 font-size-sm' : ''
                }  ${classnames({
                  active: activeTab === 0,
                })}`}
                onClick={() => {
                  toggle(0);
                }}
              >
                Pending
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`${
                  isMobile ? 'px-1 mr-1 font-size-sm' : ''
                }  ${classnames({
                  active: activeTab === 2,
                })}`}
                onClick={() => {
                  toggle(2);
                }}
              >
                Rejected
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`${
                  isMobile ? 'px-1 mr-1 font-size-sm' : ''
                }  ${classnames({
                  active: activeTab === 3,
                })}`}
                onClick={() => {
                  toggle(3);
                }}
              >
                Suspended
              </NavLink>
            </NavItem>
          </Nav>
          {roomData?.data?.room_type === 1 && (
            <>
              <Button
                type="primary"
                className={`  ml-auto rounded-lg ${isMobile ? 'mt-2 mb-3' : 'mb-2'}`}
                onClick={() => {
                  onInviteClick();
                }}
              >
                Invite Member
              </Button>
            </>
          )}
        </Row>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={1} className="active-tab">
            {memberLists}
          </TabPane>
          <TabPane tabId={0} className="pending-tab">
            {memberLists}
          </TabPane>
          <TabPane tabId={2} className="rejected-tab">
            {memberLists}
          </TabPane>
          <TabPane tabId={3} className="suspended-tab">
            {memberLists}
          </TabPane>
        </TabContent>
      </div>
    </>
  );
};
export default RoomMembers;
